import { render, staticRenderFns } from "./CoInvoiceDetail.vue?vue&type=template&id=45204168&scoped=true&"
import script from "./CoInvoiceDetail.vue?vue&type=script&lang=ts&"
export * from "./CoInvoiceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CoInvoiceDetail.vue?vue&type=style&index=0&id=45204168&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45204168",
  null
  
)

export default component.exports